module.exports = __webpack_public_path__ + "static/media/polyester_woven.bff88480.png";